module.exports = __webpack_public_path__ + "static/grandprize-prize-games-de-DE-960b10ba9f4eec0d870a28805672ad06.png";